import { isMobile } from "react-device-detect"

import apiClient from "../../helpers/apiClient"
import { sanitizeHtmlInput } from "../../helpers"
import { customerService } from "../../service/customer"
import { paymentService } from "../../service/payment"
import { createLoadingSelector } from "./Loading"

export const VERIFY_VOUCHER_BUNDLE_LINK = "VERIFY_VOUCHER_BUNDLE_LINK"
export const VERIFY_VOUCHER_BUNDLE_LINK_REQUEST = "VERIFY_VOUCHER_BUNDLE_LINK_REQUEST"
export const VERIFY_VOUCHER_BUNDLE_LINK_SUCCESS = "VERIFY_VOUCHER_BUNDLE_LINK_SUCCESS"
export const VERIFY_VOUCHER_BUNDLE_LINK_FAILURE = "VERIFY_VOUCHER_BUNDLE_LINK_FAILURE"

export const SEND_VOUCHER_BUNDLE_EMAIL = "SEND_VOUCHER_BUNDLE_EMAIL"
export const SEND_VOUCHER_BUNDLE_EMAIL_REQUEST = "SEND_VOUCHER_BUNDLE_EMAIL_REQUEST"
export const SEND_VOUCHER_BUNDLE_EMAIL_SUCCESS = "SEND_VOUCHER_BUNDLE_EMAIL_SUCCESS"
export const SEND_VOUCHER_BUNDLE_EMAIL_FAILURE = "SEND_VOUCHER_BUNDLE_EMAIL_FAILURE"

const initialState = {
	errorMessage: "",
	successMessage: "",
	voucherBundleData: null,
	name: null,
}

export const verifyingRedemptionSelector = createLoadingSelector([
	VERIFY_VOUCHER_BUNDLE_LINK,
])

export const verifyRedemption = (data) => (dispatch, getState) => {
	return dispatch({
		types: [
			VERIFY_VOUCHER_BUNDLE_LINK_REQUEST,
			VERIFY_VOUCHER_BUNDLE_LINK_SUCCESS,
			VERIFY_VOUCHER_BUNDLE_LINK_FAILURE,
		],
		callAPI: async (config) => {
			const res = await customerService.verifyEmailVoucherBundle(data, config)

			if (isMobile) {
				const {
					VoucherTypeName,
					ExpiryDate,
					TotalGifts,
					RecipientEmail,
					RedemptionPin,
					VoucherImageUrl,
				} = res.data.data
				const dynamicLink = await paymentService.getVoucherRedemptionDynamicLink(
					VoucherTypeName,
					ExpiryDate,
					TotalGifts,
					RecipientEmail,
					RedemptionPin,
					VoucherImageUrl,
					config
				)
				res.data.payload.redemptionDynamicLink = dynamicLink
			}

			return res
		},
		payload: data,
	})
}

export const sendEgiftEmailSelector = createLoadingSelector([SEND_VOUCHER_BUNDLE_EMAIL])
export const sendEgiftEmail = (d) => (dispatch, getState) => {
	const payload = {
		...d,
		name: sanitizeHtmlInput(d.name),
	}

	return dispatch({
		types: [
			SEND_VOUCHER_BUNDLE_EMAIL_REQUEST,
			SEND_VOUCHER_BUNDLE_EMAIL_SUCCESS,
			SEND_VOUCHER_BUNDLE_EMAIL_FAILURE,
		],
		callAPI: (config) => apiClient.post(`api/Egifting/EmailEgift`, payload, config),
		payload,
	})
}

export default function reducer(state = initialState, action) {
	const { payload, errorMessage, successMessage, error } = action
	const response = error ? error.response : {}
	switch (action.type) {
		case VERIFY_VOUCHER_BUNDLE_LINK_REQUEST:
			return {
				...state,
				voucherBundleData: null,
				errorMessage: "",
				successMessage: "",
			}
		case VERIFY_VOUCHER_BUNDLE_LINK_SUCCESS:
			return {
				...state,
				voucherBundleData: payload,
			}
		case VERIFY_VOUCHER_BUNDLE_LINK_FAILURE: {
			return { ...state, errorMessage: response }
		}
		case SEND_VOUCHER_BUNDLE_EMAIL_REQUEST:
			return { ...state, errorMessage: "", successMessage: "" }
		case SEND_VOUCHER_BUNDLE_EMAIL_SUCCESS:
			return { ...state, successMessage }
		case SEND_VOUCHER_BUNDLE_EMAIL_FAILURE:
			return { ...state, errorMessage }
		default:
			return state
	}
}
